import { render } from "./StepPage.vue?vue&type=template&id=6a4e8801"
import script from "./StepPage.vue?vue&type=script&lang=js"
export * from "./StepPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__